import { RateOptionList } from '@malesia/react-components/dist/src/components/Rate/Option/List';
import { SortingDataType } from '@malesia/react-components/dist/src/components/Table';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectList,
    selectIsLoading,
    selectFilterData,
    selectIsDirty,
} from '../selectors';
import { actions } from '../slice';
import { useTableColumns } from '../tableColumns';

export const OptionListWithStore: SFC = () => {
    const rateOptionList = useSelector(selectList);
    const filterData = useSelector(selectFilterData);
    const isLoading = useSelector(selectIsLoading);
    const isDirty = useSelector(selectIsDirty);

    const dispatch = useDispatch();

    const handleSetSort = (data: SortingDataType) => {
        dispatch(actions.setSorting(data));
    };

    const rateOptionListColumns = useTableColumns();

    return (
        <RateOptionList
            isLoading={isLoading}
            isDirty={isDirty}
            onSubmit={(data) => {
                dispatch(actions.setFilterData(data));
            }}
            searchText={filterData.searchText}
            isActiveOnly={filterData.isActiveOnly}
            tableColumns={rateOptionListColumns}
            tableData={rateOptionList.items}
            sortBy={filterData.sortBy}
            sortOrder={filterData.sortOrder}
            setSort={handleSetSort}
        />
    );
};
